import { render, staticRenderFns } from "./MenuHospital.vue?vue&type=template&id=2a755312&scoped=true"
import script from "./MenuHospital.vue?vue&type=script&lang=js"
export * from "./MenuHospital.vue?vue&type=script&lang=js"
import style0 from "./MenuHospital.vue?vue&type=style&index=0&id=2a755312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a755312",
  null
  
)

export default component.exports